import React, { Fragment } from 'react';
import moment from 'moment';
import { Grid } from '@material-ui/core';
import JSONViewer from 'react-json-viewer';
import LabelValueCard from './LabelValueCard';
const RevisionAddCard = ({item, dateFormat, showProject = false}) => {
  return(
    <Fragment>
      <Grid container spacing={3}>
        { showProject ?
          <Fragment>
            <LabelValueCard md={6} label='Project Number' value={item?.project_number ? `#${item?.project_number}` : '--'} />
            <LabelValueCard md={6} label='Project Name' value={item?.name || '--'} />
          </Fragment> : null
        }
        <LabelValueCard md={6} label='Created at' value={dateFormat && item?.timestamp ? moment.utc(item?.timestamp).local().format(dateFormat) : item?.timestamp} />
        <LabelValueCard md={6} label='Created by' value={item.user && item.user.name ? item.user.name:'--'} />
      </Grid>
      <div className="edit-detail-table">
        <JSONViewer json={item.changes}></JSONViewer>
      </div>
    </Fragment>
  )
}
export default RevisionAddCard;
